<script lang="ts" setup>
import type { BaseImageFragment } from "~~/types/graphql";

const props = defineProps<{
  headline: string;
  subheadline: string;
  sticker?: boolean;
  background?: BaseImageFragment;
}>();

useHeaderColor("black");
</script>
<template>
  <header class="header-blog relative flex h-4/6 flex-col bg-integer-black">
    <div v-if="background" class="absolute inset-0 z-0">
      <base-image
        v-bind="background"
        class="h-full w-full object-cover"
        eager-loading="true"
      />
      <div class="overlay default-gradient absolute inset-0" />
    </div>
    <div class="outer-space container relative z-10">
      <div
        class="grid h-full w-full content-end py-15 pt-50 text-integer-white sm:max-w-4/5"
      >
        <p v-if="props.subheadline" class="font-subline mb-4">
          {{ props.subheadline }}
        </p>
        <h1 class="hyphens-auto text-h2 md:hyphens-manual">
          {{ props.headline }}
        </h1>
      </div>
    </div>
  </header>
</template>
